import SuspenseWrapper, {
  type SuspenseWrapperProps,
} from 'javascripts/SuspenseWrapper';
import React, { forwardRef } from 'react';
import type {
  AhaEditorField as AhaEditorFieldComponent,
  AhaEditorFieldProps,
} from './AhaEditorField';

const LazyAhaEditorField = React.lazy(
  () => import(/* webpackChunkName: "aha-editor-v1" */ './AhaEditorField')
);

export const AhaEditorField = forwardRef<
  AhaEditorFieldComponent,
  AhaEditorFieldProps & SuspenseWrapperProps
>(({ fallback, ...props }, ref) => {
  return (
    <SuspenseWrapper fallback={fallback}>
      <LazyAhaEditorField ref={ref} {...props} />
    </SuspenseWrapper>
  );
});

const LazyAhaEditorCustomField = React.lazy(
  () => import(/* webpackChunkName: "aha-editor-v1" */ './AhaEditorCustomField')
);

export const AhaEditorCustomField = ({ fallback, ...props }) => {
  return (
    <SuspenseWrapper fallback={fallback}>
      <LazyAhaEditorCustomField {...props} />
    </SuspenseWrapper>
  );
};
